import { render, staticRenderFns } from "./order.vue?vue&type=template&id=506fa2e0&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=506fa2e0&prod&lang=less&scoped=true"
import style1 from "./order.vue?vue&type=style&index=1&id=506fa2e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506fa2e0",
  null
  
)

export default component.exports